/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { useIntl } from 'react-intl';

import { cssMap, cx, jsx } from '@atlaskit/css';
import Link, { type LinkProps } from '@atlaskit/link/link';
import { Box, Text } from '@atlaskit/primitives/compiled';

import { i18n } from './messages';

const AI_DISCLAIMER_LINK = 'https://www.atlassian.com/trust/atlassian-intelligence';

const styles = cssMap({
	text: {
		textDecoration: 'none',
	},
});

type AIDisclaimerProps = {
	/**
	 * Function to call when the link is clicked.
	 */
	onLinkClick?: LinkProps['onClick'];
	/**
	 * Whether to render the text as a link to the AI Trust page.
	 */
	withLink?: boolean;
};

export const AIDisclaimer = ({ onLinkClick, withLink = false }: AIDisclaimerProps): JSX.Element => {
	const { formatMessage } = useIntl();

	const disclaimerContent = (
		<Text size="small" color="color.text.subtlest">
			{formatMessage(i18n.disclaimerMessage)}
		</Text>
	);

	if (withLink) {
		return (
			<Link appearance="subtle" href={AI_DISCLAIMER_LINK} target="_blank" onClick={onLinkClick}>
				{disclaimerContent}
			</Link>
		);
	}
	return <Box xcss={cx(styles.text)}>{disclaimerContent}</Box>;
};
